<template>
  <div id="app" align="center">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
      <el-menu-item index="1"><span style="color: #5daf34">{{this.lunar}}</span></el-menu-item>
      <el-submenu index="2" :disabled="uid <= 0">
        <template slot="title">我的工作台</template>
        <el-menu-item><a href="/#/zt_dept">部门</a></el-menu-item>
        <el-menu-item><a href="/#/zt_user">用户</a></el-menu-item>
        <el-menu-item><a href="/#/zt_role">角色</a></el-menu-item>
      </el-submenu>
      <el-submenu index="3" :disabled="uid <= 0">
        <template slot="title">我的日常</template>
        <el-menu-item><a href="/#/tools">工具栏</a></el-menu-item>
        <el-menu-item><a href="/#/url">收藏夹</a></el-menu-item>
        <el-menu-item><a href="/#/sn">序列号</a></el-menu-item>
        <el-menu-item><a href="/#/dns">域名</a></el-menu-item>
        <el-menu-item><a href="/#/library">书籍</a></el-menu-item>
        <el-menu-item><a href="/#/salary">小金库</a></el-menu-item>
        <el-menu-item><a href="/#/student">小学</a></el-menu-item>
        <el-menu-item><a href="/#/children">幼儿园</a></el-menu-item>
        <el-menu-item><a href="/#/holiday">节假日</a></el-menu-item>
        <el-menu-item><a href="/#/soul">心灵鸡汤</a></el-menu-item>
        <el-menu-item><a href="/#/poem">名诗名句</a></el-menu-item>
        <el-menu-item><a href="/#/moon">古郎月行</a></el-menu-item>
        <el-menu-item><a href="/#/param">参数设置</a></el-menu-item>
      </el-submenu>
      <el-submenu index="7">
        <template slot="title">我的工具</template>
        <el-menu-item><a href="/diy/snow" target="_blank">雪花飘飘</a></el-menu-item>
        <el-menu-item><a href="/diy/bjtime" target="_blank">北京时间</a></el-menu-item>
        <el-menu-item><a href="/diy/ypt" target="_blank">云平台</a></el-menu-item>
        <el-menu-item><a href="/diy/dlt" target="_blank">大乐透</a></el-menu-item>
        <el-menu-item><a href="/diy/house" target="_blank">三家村</a></el-menu-item>
        <el-menu-item><a href="/diy/weather" target="_blank">天气</a></el-menu-item>
        <el-menu-item><a href="/map/" target="_blank">地图</a></el-menu-item>
        <el-menu-item><a href="/#/hanzi">汉字</a></el-menu-item>
        <el-menu-item><a href="/#/tangshi">唐诗</a></el-menu-item>
        <el-menu-item><a href="/#/idiom">成语</a></el-menu-item>
        <el-menu-item><a href="/#/riddle">谜语</a></el-menu-item>
        <el-menu-item><a href="/#/xiehouyu">歇后语</a></el-menu-item>
        <el-menu-item><a href="/diy/nation" target="_blank">民族</a></el-menu-item>
        <el-menu-item><a href="/diy/province" target="_blank">省份</a></el-menu-item>
      </el-submenu>
      <el-submenu index="8">
        <template slot="title">潘多拉</template>
        <el-menu-item><a href="/tools/" target="_blank">工具</a></el-menu-item>
        <el-menu-item><a href="/books/" target="_blank">书籍</a></el-menu-item>
        <el-menu-item><a href="/law/" target="_blank">定律</a></el-menu-item>
        <el-menu-item><a href="/poems/" target="_blank">唐诗</a></el-menu-item>
        <el-menu-item><a href="/poem/" target="_blank">名句</a></el-menu-item>
      </el-submenu>
      <el-menu-item index="9" disabled>消息中心</el-menu-item>
      <el-menu-item index="101" v-if="uid <= 0" @click="handleLogin">登录</el-menu-item>
      <el-menu-item index="102" v-else @click="handleLogout">注销</el-menu-item>
    </el-menu>

    <div style="font-size:13px" align="center">
      <br><br>
      <img :src="this.imgUrl" width=auto height=300/>
      <br><br>
      <span style="font-size: large; ">{{this.soul}}</span>
      <br><br>
<!--      <span style="color: green; ">=== 30年的传承，360月的奋斗，10950天的锤炼！ ===</span>-->
      <br><br>
      <p><span style="font-size: x-small; ">&copy;{{this.year}}&nbsp;&nbsp;&nbsp;&nbsp;milkfans.cn</span>
        &nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备2022002148号-1</a></p>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="账号" prop="user" :rules="[{required: true, message: '账号为空'}]">
          <el-input v-model="form.user" maxlength="50" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" :rules="[{required: true, message: '密码为空'}]">
          <el-input v-model="form.password" show-password clearable maxlength="50" style="width: 280px"></el-input>
        </el-form-item>
<!--        <el-form-item label="授权码" prop="key" :rules="[{required: true, message: '授权码为空'}]">-->
<!--          <el-input v-model="form.key" show-password clearable @keyup.enter.native="list" maxlength="50" style="width: 280px"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="验证码" prop="inputCode">
          <el-input v-model="form.inputCode" clearable maxlength="50" style="width: 110px"></el-input>
          <el-input class="code" v-model="this.checkCode" readonly maxlength="50" style="width: 80px"></el-input>
          <span @click="createCode(4)">看不清换一张</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取消</el-button>
        <el-button type="primary" @click="login('form')"><span>登录</span></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as http from '../api/http'
// import md5 from 'js-md5'
import global from '../components/Global'
// import * as util from '../util/util'

export default {
  name: 'Index',
  data () {
    return {
      checkCode: '',
      dialogStatus: '',
      dialogTitle: '',
      dialogVisible: false,
      form: {inputCode: ''},
      uid: 0,
      baseUrl: '',
      activeIndex: '1',
      activeIndex2: '1',
      lunar: null,
      imgUrl: '',
      soul: '',
      year: 2021
    }
  },
  created () {
    this.createCode(4)
    this.getCurrentYear()
    this.getLunar()
    this.getImage()
    this.getSoul()
  },
  mounted () {
    // this.uid = this.$cookies.get('uid0')
    this.uid = global.uid
  },
  activated () {
    // this.uid = global.uid
  },
  methods: {
    createCode (length) {
      let code = ''
      let codeLength = parseInt(length) // 验证码的长度

      // 所有候选组成验证码的字符，当然也可以用中文的
      let codeChars = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
      // 循环组成验证码的字符串
      for (let i = 0; i < codeLength; i++) {
        // 获取随机验证码下标
        let charNum = Math.floor(Math.random() * 62)

        // 组合成指定字符验证码
        code += codeChars[charNum]
      }
      this.checkCode = code
    },
    validateCode () {
      let checkCode = this.checkCode // document.getElementById('checkCode').innerHTML
      let inputCode = this.form.inputCode // document.getElementById("inputCode").value
      // console.log(checkCode)
      // console.log(inputCode)
      if (inputCode === undefined || inputCode.length <= 0) {
        alert('请输入验证码！')
      } else if (inputCode.toUpperCase() !== checkCode.toUpperCase()) {
        alert('验证码输入有误！')
        this.createCode(4)
      } else {
        // alert("验证码正确！")
        return true
      }

      return false
    },
    handleLogout () {
      this.$confirm('确定注销？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.uid = 0
        // this.token = ''

        // global.uid = 0
        // global.token = ''

        // 删除cookie
        // this.$cookies.remove('uid0')
        // this.$cookies.remove('token0')
      })
    },
    login () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.validateCode()) {
            return
          }
          // let pwd = this.form.pwd0
          // pwd = md5('1' + pwd)
          // pwd = md5('2' + pwd.substr(0, 30))
          // pwd = pwd.substr(0, 30)
          // this.form.pwd = pwd
          // console.log(pwd)
          http.post(global.url0 + 'nsy-user/login/', this.form).then(
            res => {
              // console.log(res)
              let data = res.data
              if (data['id'] !== undefined) {
                let uid = data['id']
                let token = data['token']

                this.uid = uid
                // global.uid = uid
                // global.token = token
                localStorage.setItem('token', token)

                // 设置cookie默认过期时间单位是1d(1天)
                // this.$cookies.set('uid0', uid)
                // this.$cookies.set('token0', token)

                this.dialogVisible = false
              } else {
                this.$message.error('登录失败，请检查输入是否正确。')
              }
            }
          )
        }
      })
    },
    handleLogin () {
      this.form = {}
      this.dialogStatus = 'login'
      this.dialogTitle = '用户登录'
      this.dialogVisible = true
    },
    getLunar () {
      http.get(global.urlOld + 'Today/lunar')
        .then(res => {
          this.lunar = '今天是 ' + res.day + ' ' + res.week + res.lunar
        })
    },
    getImage () {
      http.get(global.urlOld + 'Image/get')
        .then(res => {
          this.imgUrl = '/Images/english/' + res + '.jpg'
        // console.log(this.img)
        })
    },
    getSoul () {
      http.get(global.urlOld + 'Soul/random')
        .then(res => {
          this.soul = res
        })
    },
    getCurrentYear () {
      let date = new Date()
      this.year = date.getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .code >>> .el-input__inner {
    font-family:Arial;
    font-style:italic;
    color:blue;
    /*font-size:14px;*/
    /*border:0;*/
    /*padding:2px 3px;*/
    /*letter-spacing:3px;*/
    /*font-weight:bolder;*/
    /*float:right;*/
    /*cursor:pointer;*/
    /*width:80px;*/
    /*height:30px;*/
    /*line-height:30px;*/
    text-align:center;
    vertical-align:middle;
    background-color:#D8B7E3;
  }
  /*span {*/
  /*  text-decoration:none;*/
  /*  font-size:12px;*/
  /*  color:#288bc4;*/
  /*  padding-left:10px;*/
  /*}*/
  /*span:hover {*/
  /*  text-decoration:underline;*/
  /*  cursor:pointer;*/
  /*}*/
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/views/Index.vue